import type { ElementType } from '../../types';

const ADVANTAGES: Record<ElementType, ElementType> = {
  FIRE: 'FOREST',
  FOREST: 'WIND',
  WIND: 'MOUNTAIN',
  MOUNTAIN: 'FIRE',
};

export class ElementSystem {
  constructor(
    private readonly advantage = 1.15,
    private readonly neutral = 1,
    private readonly disadvantage = 0.9,
  ) {}

  multiplier(attacker: ElementType | 'VOID', defender: ElementType | 'VOID'): number {
    if (attacker === 'VOID' || defender === 'VOID' || attacker === defender) return this.neutral;
    if (ADVANTAGES[attacker] === defender) return this.advantage;
    if (ADVANTAGES[defender] === attacker) return this.disadvantage;
    return this.neutral;
  }

  getElementMultiplier(attacker: ElementType | 'VOID', defender: ElementType | 'VOID'): number {
    return this.multiplier(attacker, defender);
  }

  hasAdvantage(attacker: ElementType, defender: ElementType): boolean {
    return ADVANTAGES[attacker] === defender;
  }

  hasElementAdvantage(attacker: ElementType, defender: ElementType): boolean {
    return this.hasAdvantage(attacker, defender);
  }

  hasElementDisadvantage(attacker: ElementType, defender: ElementType): boolean {
    return ADVANTAGES[defender] === attacker;
  }
}
